(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-page"]) return;
  try {
    
(function() {
  var productData = window.__productData__;
  if (!productData) return;

  var form = document.getElementById('product-form');
  if (!form) return;

  var mainImg = document.getElementById('gallery-main-img');
  var variantIdInput = document.getElementById('variant-id');
  var addBtn = document.getElementById('add-to-cart-btn');
  var priceEl = document.getElementById('product-price');

  function getSelectedVariant() {
    var radios = form.querySelectorAll('.variant-radio:checked');
    var opts = [];
    radios.forEach(function(r) { opts.push(r.value); });
    return productData.variants.find(function(v) {
      return (!opts[0] || v.option1 === opts[0]) &&
             (!opts[1] || v.option2 === opts[1]) &&
             (!opts[2] || v.option3 === opts[2]);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateVariant() {
    var variant = getSelectedVariant();
    if (!variant) return;
    variantIdInput.value = variant.id;

    var priceNow = priceEl.querySelector('.price-now');
    if (priceNow) priceNow.textContent = formatMoney(variant.price);

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (!variant.available) {
        addBtn.textContent = 'Sold out';
      } else {
        addBtn.textContent = addBtn.dataset.original || addBtn.textContent;
      }
    }

    if (variant.featured_image && mainImg) {
      mainImg.src = variant.featured_image.src;
    }
  }

  if (addBtn) addBtn.dataset.original = addBtn.textContent;

  form.querySelectorAll('.variant-radio').forEach(function(r) {
    r.addEventListener('change', updateVariant);
  });

  var thumbs = document.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.full;
    });
  });

  var minusBtn = form.querySelector('[data-action="minus"]');
  var plusBtn = form.querySelector('[data-action="plus"]');
  var qtyInput = form.querySelector('.qty-input');

  if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    plusBtn.addEventListener('click', function() {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
